// @flow

export default function googleOneTapFailed() {
  return {
    type: 'GOOGLE_ONE_TAP_FAILED',
    payload: {},
  };
}
